import { c as _c } from "react/compiler-runtime";
import React from 'react';
export const AddChatIcon = React.forwardRef<SVGSVGElement>((props, ref) => {
  const $ = _c(5);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M15.8555 11.6406H9.85547M12.8555 14.6406V8.64062" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />;
    t1 = <path d="M12.8037 3.64062V2.64062V2.64062V3.64062ZM20.8037 11.6406H21.8037H20.8037ZM4.45508 19.6406L3.76236 18.9194C3.46801 19.2021 3.37501 19.6354 3.52739 20.014C3.67977 20.3926 4.04695 20.6406 4.45508 20.6406V19.6406ZM7.02539 17.1719L7.7181 17.8931C8.11598 17.5109 8.12921 16.8788 7.74768 16.4803L7.02539 17.1719ZM4.80371 11.6406H3.80371H4.80371ZM12.8037 3.64062V4.64062C16.6697 4.64062 19.8037 7.77463 19.8037 11.6406H20.8037H21.8037C21.8037 6.67006 17.7743 2.64062 12.8037 2.64062V3.64062ZM20.8037 11.6406H19.8037C19.8037 15.5066 16.6697 18.6406 12.8037 18.6406V19.6406V20.6406C17.7743 20.6406 21.8037 16.6112 21.8037 11.6406H20.8037ZM12.8037 19.6406V18.6406H4.45508V19.6406V20.6406H12.8037V19.6406ZM4.45508 19.6406L5.14779 20.3618L7.7181 17.8931L7.02539 17.1719L6.33268 16.4507L3.76236 18.9194L4.45508 19.6406ZM7.02539 17.1719L7.74768 16.4803C6.54278 15.2219 5.80371 13.5187 5.80371 11.6406H4.80371H3.80371C3.80371 14.0551 4.75654 16.2483 6.3031 17.8635L7.02539 17.1719ZM4.80371 11.6406H5.80371C5.80371 7.77463 8.93772 4.64063 12.8037 4.64062V3.64062V2.64062C7.83315 2.64063 3.80371 6.67006 3.80371 11.6406H4.80371Z" fill="currentColor" />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] !== props || $[3] !== ref) {
    t2 = <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props} ref={ref}>{t0}{t1}</svg>;
    $[2] = props;
    $[3] = ref;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
});
export default AddChatIcon;